import React from 'react';

// Component
import BigBassLeaderDescription from './BigBassLeader';

interface IAnglerCell {
  anglerName: string;
  isLeader?: boolean;
  isExpanded: boolean;
  index: number;
  width: number;
  tid?: number;
}
const AnglerCell = (props: IAnglerCell) => {
  const { anglerName, index, isLeader, isExpanded, width, tid } = props;
  let AnglerName;

  if (width <= 768) {
    const [first, last, suffix] = anglerName.split(' ');
    AnglerName = () => (
      <div className="angler-name" data-angler={anglerName}>
        <div className="angler-name__first">{first}</div>
        <div className="angler-name__last">
          {last} {suffix ? suffix : null}
        </div>
      </div>
    );
  } else {
    AnglerName = () => (
      <>
        <div className="angler-name" data-angler={anglerName}>
          {anglerName}
        </div>
      </>
    );
  }
  return (
    <>
      <AnglerName />
      <span
        className={`angler-toggle ${isExpanded ? 'active' : 'inactive'}`}
        itemID={`${index + 1}`}
      ></span>
      {isLeader && <BigBassLeaderDescription tid={tid} />}
    </>
  );
};

export default AnglerCell;
